import { type FC } from "react";
import { type BaseFieldProps, Field, type WrappedFieldProps } from "redux-form";

import Radio from "./Radio.js";
import { FormInputGroup } from "@/ui-modules/core/form/layout/FormGroup.js";
import { FormInputWidget } from "@/ui-modules/core/form/layout/FormInputWidget.js";
import { FormLabel } from "@/ui-modules/core/form/layout/FormLabel.js";

export interface IRadioProps {
  label: string;
  tooltipText: string;
  name: string;
}

export interface IRadioButtonSelectorProps extends Partial<WrappedFieldProps> {
  //input?: any; // injected as WrappedFieldProps
  //meta?: any; // injected as WrappedFieldProps

  options?: IRadioProps[];
  label?: string;
  disabled?: boolean;
  handleChange?: (selectedOption: string) => void;
  horizontalLayout?: boolean;
  radioButtonsAlignedVertically?: boolean;
}

/**
 * Radio button group
 *
 * created on 2/2/2018
 */
const RadioButtonSelector: FC<IRadioButtonSelectorProps> = (props) => {
  return (
    <FormInputGroup horizontalLayout={props.horizontalLayout}>
      <FormLabel>{props.label}</FormLabel>
      <FormInputWidget>
        <div className={"radio radio-custom"} style={{ paddingLeft: 15 }}>
          {props.options.map((x: IRadioProps) => (
            <Radio
              key={`radio-${x.name}`}
              id={`radio-${x.name}`}
              name={`radio-${x.name}`}
              value={`${x.name}`}
              checked={x.name === props.input.value}
              label={x.label}
              tooltipText={x.tooltipText}
              onChange={(e) => {
                props.input.onChange(e);
                if (props.handleChange) {
                  props.handleChange(x.name);
                }
              }}
              style={{ display: props.radioButtonsAlignedVertically ? "block" : "inline-block" }}
              disabled={props.disabled}
            />
          ))}
        </div>
      </FormInputWidget>
    </FormInputGroup>
  );
};

export default RadioButtonSelector;

export function RadioButtonReduxFormField(props: IRadioButtonSelectorProps & BaseFieldProps) {
  return <Field {...props} />;
}
